var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPan = function SvgPan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.213 32.463c3.325-.186 6.162-1.208 8.507-2.982a16.282 16.282 0 0 0 5.28-6.95l-5.278-2.242a10.42 10.42 0 0 1-3.379 4.448 9.99 9.99 0 0 1-5.13 2.005v5.721ZM23.213.001c3.362.188 6.162 1.266 8.507 3.054A16.397 16.397 0 0 1 37 10.06l-5.278 2.26a10.494 10.494 0 0 0-3.379-4.484c-1.5-1.145-3.276-1.903-5.13-2.07V.002Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 29.754c2.363 1.665 5.201 2.646 8.302 2.78v-5.76c-2.558-.194-4.95-1.393-6.693-3.345-1.745-1.95-2.713-4.516-2.709-7.178.004-2.662.979-5.223 2.729-7.17 1.75-1.945 4.144-3.131 6.703-3.319V0c-4.325 0-8.14 2-10.875 5.04-2.734 3.04-4.257 7.043-4.263 11.203-.005 3.705 1.194 7.289 3.382 10.182L.597 35.2c-.765.78-.766 1.878-.167 2.684.599.805.896 1.131 1.25 1.435.354.303 1.69 1.201 2.758.272.871-.758 6.196-6.762 8.896-9.836Zm-8.8 6.804c0 .66-.521 1.196-1.164 1.196-.642 0-1.163-.535-1.163-1.196 0-.661.52-1.197 1.163-1.197s1.163.536 1.163 1.197Z",
    fill: "#fff"
  })));
};
export default SvgPan;